import React, {useCallback, useEffect, useMemo, useState} from 'react'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
// import AssignStaffPopup from './ProfilePageComponent/AssignStaffPopup'

import ChangeAssignedStaff from './modal/ChangeAssignedStaff'

import {
  deallocateUser,
  getAllAssigneeUser,
  getAllAssigneeUserExport,
  getAllUserAssignedToStaffList,
} from './StaffProfileDetailSlice/StaffProfileDetailSlice'
import {KTSVG, useDebounce} from '../../../../../../_metronic/helpers'
import {GetAllStaff, GetAllStaffForStaffAdmin} from '../StaffAccountSlice/StaffAccountSlice'
import DeleteConfirmationPopup from '../../../../../Components/DeleteConfirmationPopup'
import {getUserData} from '../../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import NodataYet from '../../../../../Components/NodataYet'
import ChangeCOG from './modal/ChangeCog'
import {useAdminUpdateUserCOGMutation} from '../../../../../../services/cellcast'
import {toast} from 'react-toastify'
import {Spinner} from 'react-bootstrap'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {GetUserData} from '../../../../../Redux/AdminPanel/ProfileDetailsSlice'

const AssignUser = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [assign, setAssign] = useState(false)
  const ProfileDetatileState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const param = useLocation()
  const Role = useSelector(getUserData)
  const List = useSelector(getAllUserAssignedToStaffList)
  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deallocate, setDeallocate] = useState({
    userId: ProfileDetatileState?._id,
    staffId: '',
  })
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })

  const [assignTo, setAssignTo] = useState({
    userId: ProfileDetatileState?._id,
    accountManagerId: '',
    salesId: '',
  })

  const [openCOG, setOpenCOG] = useState(false)
  const [updateUserCOG] = useAdminUpdateUserCOGMutation()

  const debouncedSearchTerm = useDebounce(page?.search, 3000)
  const [isExportLoading, setIsExportLoading] = useState(false)

  const AssignStaff = useMemo(
    () => (
      <ChangeAssignedStaff
        list={assignTo}
        setAssign={setAssignTo}
        show={assign}
        handleClose={() => setAssign(false)}
      />
    ),
    [assign, assignTo]
  )
  useEffect(() => {
    dispatch(getAllAssigneeUser({userId: ProfileDetatileState?._id, ...page}))
  }, [debouncedSearchTerm, page.page, page.size])

  useEffect(() => {
    if (confirm == true) {
      dispatch(deallocateUser(deallocate))
    }
    setConfirm(false)
  }, [confirm])

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to ?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const handleUpdateAction = (cog: {
    sms: number
    mms: number
    commissionInboundRates: any[]
    commissionOutboundRates: any[]
  }) => {
    updateUserCOG({
      userId: deallocate.userId,
      cog: {sms: cog.sms, mms: cog.mms},
      commissionInboundRates: cog.commissionInboundRates,
      commissionOutboundRates: cog.commissionOutboundRates,
    })
      .unwrap()
      .then((res) => {
        toast.success(res.message)
        dispatch(getAllAssigneeUser({userId: ProfileDetatileState?._id, ...page}))
      })
  }

  const handleExportData = useCallback(() => {
    setIsExportLoading(true)
    dispatch(getAllAssigneeUserExport({userId: ProfileDetatileState?._id}))
      .unwrap()
      .then((res: any) => {
        window.open(`${API_DOMAIN}${res?.data?.downloadurl}`, '_self')
      })
      .finally(() => {
        setIsExportLoading(false)
      })
  }, [API_DOMAIN, ProfileDetatileState?._id, dispatch])

  const cogChange = useMemo(
    () => (
      <ChangeCOG
        show={openCOG}
        handleClose={() => setOpenCOG(false)}
        handleUpdate={handleUpdateAction}
        user={List?.items?.find((it: any) => it._id === deallocate.userId)}
      />
    ),
    [openCOG]
  )

  const handleDelete = (id: any) => {
    setOpen(true)

    setDeallocate({...deallocate, userId: id, staffId: ProfileDetatileState?._id})
  }

  const handleUpdate = (id: any) => {
    setOpenCOG(true)

    setDeallocate({...deallocate, userId: id})
  }

  useEffect(() => {
    if (param.pathname?.split('/').includes('user-profile')) {
      if (Role == 'superAdmin') {
        dispatch(GetAllStaff(page))
      }

      if (Role == 'staffAdmin') {
        dispatch(GetAllStaffForStaffAdmin(page))
      }
    }
  }, [])

  useEffect(() => {
    setAssignTo({
      ...assignTo,
      accountManagerId: List?.items?.filter((key: any) => key?.role == 'accountManager')?.[0]?._id,
      salesId: List?.items?.filter((key: any) => key?.role !== 'accountManager')?.[0]?._id,
    })
  }, [List])

  return (
    <>
      {confirmation}
      {AssignStaff}
      {cogChange}

      <div className={`sub-accountstable card `}>
        <div className='card'>
          <div className='card-body'>
            <div className='d-flex flex-wrap flex-sm-nowrap'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <a className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                        Assigned User
                      </a>
                    </div>
                  </div>

                  <div className='d-flex mb-3'>
                    <div
                      className='card-toolbar'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title='Click to add a user'
                    >
                      <div className='d-flex align-items-center position-relative my-1'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen021.svg'
                          className='svg-icon-1 position-absolute ms-6'
                        />
                        <input
                          type='text'
                          data-kt-user-table-filter='search'
                          className='form-control form-control-solid w-250px ps-14'
                          placeholder='Search user'
                          value={page?.search}
                          onChange={(e) =>
                            setPage({...page, search: e.target.value, page: 1, size: 10})
                          }
                        />
                      </div>
                    </div>
                    <div className='d-flex align-items-center'>
                      <button
                        type='button'
                        className='btn btn-primary btn-md ms-2'
                        onClick={() => handleExportData()}
                      >
                        {isExportLoading ? <Spinner /> : 'Export'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {List?.items?.length > 0 ? (
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bolder text-muted'>
                    <th className='min-w-100px'>USER</th>
                    <th className='min-w-100px'>CREATED ON</th>
                    <th className='min-w-50px'>SMS COG</th>
                    <th className='min-w-50px'>MMS COG</th>
                    <th className='min-w-50px'>COMMISION RATE%</th>
                    <th className='min-w-100px '>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {List?.items?.map((data: any, idx: number) => (
                    <tr key={idx}>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div
                            onClick={() => navigate('/user-profile', {state: [data, 'user']})}
                            className='symbol symbol-45px me-5'
                          >
                            <span className='circle1'>{`${data?.firstName
                              ?.split('')[0]
                              .toUpperCase()}${
                              data?.lastName !== undefined && data?.lastName !== ''
                                ? data?.lastName?.split('')[0]
                                : ''
                            }`}</span>
                          </div>
                          <div className='d-flex justify-content-start flex-column'>
                            <a
                              href='#'
                              onClick={(e) => {
                                e.preventDefault()
                                dispatch(GetUserData(data?._id)).then((res: any) => {
                                  if (res?.payload?.data) {
                                    navigate('/user-profile', {
                                      state: {userProp: res?.payload?.data},
                                    })
                                  }
                                })
                              }}
                              className='text-dark fw-bolder text-hover-primary fs-6'
                            >
                              {`${data?.firstName} ${data?.lastName}`}
                            </a>
                            <span className='text-muted fw-bold text-muted d-block fs-7'>
                              {data?.email}
                            </span>
                          </div>
                        </div>
                      </td>
                      {ProfileDetatileState?.role === 'owner' && <td>{data?.role}</td>}
                      <td>
                        <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                          {moment(data?.createdAt).format('DD/MM/YYYY')}
                        </span>
                      </td>
                      <td>{data?.cog?.sms}</td>
                      <td>{data?.cog?.mms}</td>
                      <td>{data?.cog?.commissionPercentage}%</td>
                      {
                        <td>
                          <div className='d-flex justify-content-between'>
                            <div
                              onClick={() => handleDelete(data?._id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            >
                              <i className='bi bi-trash'></i>
                            </div>

                            <div
                              onClick={() => handleUpdate(data?._id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ml-2'
                            >
                              <i className='bi bi-pencil'></i>
                            </div>
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>
              {ProfileDetatileState?.role !== 'owner' && (
                <div className='abcd '>
                  {/* <select
                  //  onChange={(e: any) => setPage({...page, size: e.target.value})}
                  >
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                    <option>ALl</option>
                  </select> */}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={List?.totalPages}
                    onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default AssignUser
